import React, { useState, useEffect } from "react";
import "../styles/amount.css";
import Header from "./header";
import { useNavigate } from "react-router-dom";
import { startPaymentOverlay } from "../middleware/microapp";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function Amount() {
  const [selectedAmount, setSelectedAmount] = useState("");
  const [isAmountSelected, setIsAmountSelected] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [status, setStatus] = useState("Success");
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();

  const handleAmountSelect = (amount) => {
    setSelectedAmount(amount);
    setIsAmountSelected(true);
    setErrorMessage("");
  };

  const handleCustomAmountChange = (event) => {
    event.preventDefault();
    const inputText = event.target.value;

    if (/^ZAR [1-9]\d{0,4}(\.\d{0,2})?$/.test(inputText)) {
      const amount = inputText.replace("ZAR ", "");
      setSelectedAmount(amount);
      setIsAmountSelected(amount >= 1);
      setErrorMessage("");
    } else {
      if (inputText === "ZAR") {
        setSelectedAmount("");
      } else {
        setSelectedAmount("");
        setIsAmountSelected(false);
        setErrorMessage(
          <span style={{ color: "red", fontSize: "12px", marginLeft: "20px" }}>
            Invalid amount. Please enter a valid amount.
          </span>
        );
      }
    }
  };

  const startPayment = () => {
    if (selectedAmount) {
      startPaymentOverlay(parseFloat(selectedAmount), "ZAR", "test");
    }
  };

  const closeModal = () => {
    setShowModal(false);
  };

  useEffect(() => {
    window["onPaymentStatusChanged"] = (transactionId, status, error) => {
      if (status === "Cancel" || status === "FAILURE") {
        setStatus(status);
        setShowModal(true);
      } else if (status === "Success") {
        navigate("/thankyou");
      }
      console.log(status);
    };
  }, [navigate]);

  return (
    <div>
      <Header />
      <div
        className='modal'
        tabIndex='-1'
        role='dialog'
        style={{ display: showModal ? "flex" : "none" }}
      >
        <div className='modal-dialog' role='document'>
          <div className='modal-content border border-0'>
            <div className='modal-header border border-0 flex d-flex justify-content-center'>
              {status === "Cancel" ? (
                <h5 className='modal-title'>Transaction Cancelled!</h5>
              ) : (
                <h5 className='modal-title'>Transaction Failed!</h5>
              )}
            </div>
            <div className='modal-body'>
              {status === "FAILURE"
                ? "Payment reached the maximum amount."
                : "The transaction was cancelled by the user."}
            </div>
            <div className='modal-footer border border-0 flex d-flex justify-content-center'>
              <button
                type='button'
                className='btn btn-primary flex d-flex justify-content-center'
                onClick={closeModal}
              >
                <span className='okbutton'>OK</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className='container-fluid'>
        <div className=' card mt-2 py-3 rounded-4 mb-5'>
          <div>
            <ToastContainer />
          </div>
          <div className='ukhanya-top-text mb-2 px-3'>
            <h4>Donate to uKhanya Foundation</h4>
            <p>Choose an amount to donate below</p>
          </div>
          <div className='row p-2'>
            <div className='col-6 my-1'>
              <div
                className={`text-center amounts ${
                  isAmountSelected && selectedAmount === "R50" ? "selected" : ""
                }`}
                onClick={() => handleAmountSelect("50.00")}
              >
                <span className='rands text-center'>R50</span>
              </div>
            </div>
            <div className='col-6 my-1'>
              <div
                className={`text-center amounts ${
                  isAmountSelected && selectedAmount === "R100"
                    ? "selected"
                    : ""
                }`}
                onClick={() => handleAmountSelect("100.00")}
              >
                <span className='rands text-center'>R100</span>
              </div>
            </div>
            <div className='col-6 my-1'>
              <div
                className={`text-center amounts ${
                  isAmountSelected && selectedAmount === "R250"
                    ? "selected"
                    : ""
                }`}
                onClick={() => handleAmountSelect("250.00")}
              >
                <span className='rands text-center'>R250</span>
              </div>
            </div>
            <div className='col-6 my-1'>
              <div
                className={`text-center amounts ${
                  isAmountSelected && selectedAmount === "R1000"
                    ? "selected"
                    : ""
                }`}
                onClick={() => handleAmountSelect("1000.00")}
              >
                <span className='rands text-center'>R1000</span>
              </div>
            </div>
          </div>
        </div>

        <div className='card mt-2 py-2 rounded-4'>
          <div className='ukhanya-top-text mb-2 px-3'>
            <h4>Own amount</h4>
            <p>Donate your own amount</p>
          </div>

          <div className='input-group py-2 px-3'>
            <input
              type='text'
              aria-label='Sizing example input'
              aria-describedby='inputGroup-sizing-default'
              inputMode='numeric'
              value={`ZAR ${selectedAmount}`}
              onChange={handleCustomAmountChange}
            />
          </div>
          {errorMessage && <div className='error-message'>{errorMessage}</div>}
        </div>
      </div>

      <footer>
        <div className='donate-now'>
          <button
            onClick={() => startPayment()}
            className={`btn-donate ${
              !isAmountSelected || errorMessage ? "disabled-button" : ""
            }`}
            disabled={!isAmountSelected || errorMessage}
          >
            {isAmountSelected ? "Donate Now" : "Continue"}
          </button>
        </div>
      </footer>
    </div>
  );
}
